import React from 'react';
import { HashRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
//import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './styles/global.css';
import WelcomePage from './pages/WelcomePage.jsx';
import PayrollReporting from './pages/PayrollReporting.jsx';
import ValidateCode from './components/ValidateCode.jsx';
import RegisterHolder from './components/RegisterHolder.jsx';
import RegistrationComplete from './components/RegistrationComplete.jsx';
import PolicyholderAlreadyExists from './components/PolicyholderAlreadyExists.jsx';
import logo from './assets/republic_indemnity_logo.png';
import gaigLogo from './assets/GAIG-Logo-Footer.png';

function getCurrentYear() {
  return new Date().getFullYear();
}

function getPublicURL() {
  const origin = window.location.origin;
  if (origin.includes('securedev')) {
    return 'https://wwwdev.republicindemnity.com/';
  } else if (origin.includes('secureqac')) {
    return 'https://wwwqac.republicindemnity.com/';
  } else {
    return 'https://www.republicindemnity.com/';
  }
}

function Header() {
  const location = useLocation();
  return (
    <section className="hero is-small is-primary app-header-section" style={{ backgroundColor: '#0b3b60' }}>
      <div className="hero-body">
        <div className="title">
          <div className="header-row" style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center'}}>
            <div className="header-col logo-col" style={{flex: '1 1 120px', minWidth: 80}}>
              <img src={logo} alt="Republic Indemnity Logo" className="b-component-header-brand-logo__img" style={{height: '60px', width: '120px', objectFit: 'contain'}} />
            </div>
            <div className="header-col title-col" style={{flex: '2 1 200px', minWidth: 120}}>
              <span className="b-component-header-text-title">
                Workers Compensation{' '}
                {location.pathname === '/payroll' ? 'Payroll Reporting' : 'Policyholder Registration'}
              </span>
            </div>
            <div className="header-col right-col" style={{flex: '1 1 180px', minWidth: 120, textAlign: 'right'}}>
              <span className="b-component-header-text-right">
                <Link to="/account-management">Login</Link> |{' '}
                <a href={getPublicURL()} target="_blank" rel="noopener noreferrer">Public Site</a>&nbsp;&nbsp;
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer>
      <div className="content">
        <div className="footer-row" style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between'}}>
          <div className="footer-col nav-col" style={{flex: '3 1 300px', minWidth: 180}}>
            <div className="wrapper-nav-list-home">
              <ul id="navlist">
                <li>
                  <a href="https://www.republicindemnity.com/legal-disclosure" target="_blank" rel="noopener noreferrer">Legal Disclosures</a>
                </li>
                <li className="copy">
                  <span> ©2001- {getCurrentYear()} Republic Indemnity Company of America.</span>
                  <span> All rights reserved.</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-col logo-footer-col" style={{flex: '1 1 120px', minWidth: 100, textAlign: 'right'}}>
            <div className="wrapper-gai-logo">
              <a className="gai-logo" href="http://www.greatamericaninsurancegroup.com/Pages/default.aspx" target="_blank" rel="noopener noreferrer">
                <img src={gaigLogo} alt="GAIG Logo" className="b-component-header-brand-footer__img" style={{height: '60px', width: '160px', objectFit: 'contain'}} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function App() {
  return (
    <Router>
      <Header />
      <div style={{ minHeight: '60vh' }}>
        <Routes>
          <Route path="/" element={<ValidateCode />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/payroll" element={<PayrollReporting />} />
          <Route path="/register" element={<RegisterHolder />} />
          <Route path="/regcomplete" element={<RegistrationComplete />} />
          <Route path="/polexists" element={<PolicyholderAlreadyExists />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
